import { render } from "./xiangmu.vue?vue&type=template&id=f3d9b4ce&scoped=true"
import script from "./xiangmu.vue?vue&type=script&lang=js"
export * from "./xiangmu.vue?vue&type=script&lang=js"

import "./xiangmu.vue?vue&type=style&index=0&id=f3d9b4ce&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3d9b4ce"]])

export default __exports__